module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/bg_04-a064bb75228a5d5fca913e9f4cf637b3.jpg";